import { render, staticRenderFns } from "./TextareaWidth.vue?vue&type=template&id=2647bc8a"
import script from "./TextareaWidth.vue?vue&type=script&lang=js"
export * from "./TextareaWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports